import { Cartesian3 } from "cesium";
import { ArcSegment } from "../../geometric-elements/arc-segment";
import { BaseHorizontalAlignmentSegment } from "./horizontal-alignment-base-segment";
import { CurveDataType, } from "./interface";
import { PathUtils } from "../../../utilities/path-utils";
export class HACircularSegment extends BaseHorizontalAlignmentSegment {
    type = CurveDataType.CIRCULAR_SEGMENT;
    startPoint;
    endPoint;
    anchorPoint;
    element;
    constructor(startPoint, endPoint, anchorPoint) {
        super();
        this.startPoint = startPoint;
        this.endPoint = endPoint;
        this.anchorPoint = anchorPoint;
        this.recomputeElement();
    }
    isStartPoint(pointId) {
        return this.startPoint.id === pointId;
    }
    isEndPoint(pointId) {
        return this.endPoint.id === pointId;
    }
    get data() {
        return {
            type: CurveDataType.CIRCULAR_SEGMENT,
            startPointId: this.startPoint.id,
            endPointId: this.endPoint.id,
            anchorPointId: this.anchorPoint.id,
        };
    }
    get surveyPoints() {
        return [this.startPoint, this.anchorPoint, this.endPoint];
    }
    dispose() {
        this.element?.dispose();
        this.startPoint = undefined;
        this.anchorPoint = undefined;
        this.endPoint = undefined;
    }
    containsPointId(pointId) {
        return (this.startPoint.id === pointId ||
            this.endPoint.id === pointId ||
            this.anchorPoint.id === pointId);
    }
    recomputeElement() {
        this.element?.dispose();
        const startPoint = new Cartesian3(this.startPoint.localPoint.x, this.startPoint.localPoint.y, 0);
        const endPoint = new Cartesian3(this.endPoint.localPoint.x, this.endPoint.localPoint.y, 0);
        const anchorPoint = new Cartesian3(this.anchorPoint.localPoint.x, this.anchorPoint.localPoint.y, 0);
        const { center } = PathUtils.getCenterAndRadiusfromTwoPointsAndAnchorPoint(startPoint, endPoint, anchorPoint);
        this.element = ArcSegment.fromCenterAndTwoPoints({
            start: startPoint,
            end: endPoint,
            center: center,
        });
    }
}
//# sourceMappingURL=horizontal-alignment-circular-segment.js.map